/* Robe Swim — Tre Perle storefront helpers: add the set, quick add, size swap in cart, sticky add to bag */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer', 'cart-counter'];

  function drawer() { return document.querySelector('cart-drawer'); }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) { throw new Error(data.description || data.message || 'Something went wrong'); }
        return data;
      });
    });
  }

  function addItems(items) {
    return post('cart/add.js', { items: items, sections: SECTIONS, sections_url: window.location.pathname }).then(function (data) {
      var d = drawer();
      if (d && typeof d.renderContents === 'function' && data.sections) { d.renderContents(data); }
      else { window.location.href = root + 'cart'; }
      document.dispatchEvent(new CustomEvent('tp:cart-updated'));
      return data;
    });
  }

  function say(el, text) { if (el) { el.textContent = text; } }

  /* Complete the set: two size pickers, one button */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tp-set-form]');
    if (!form) return;
    e.preventDefault();
    var msg = form.querySelector('[data-tp-msg]');
    var selects = form.querySelectorAll('select[data-tp-set-select]');
    var items = [];
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) { say(msg, form.getAttribute('data-missing')); selects[i].focus(); return; }
      items.push({ id: Number(selects[i].value), quantity: 1 });
    }
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    say(msg, '');
    addItems(items).then(function () { say(msg, form.getAttribute('data-added')); })
      .catch(function (err) { say(msg, err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* Quick add (pairs with, cart row) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tp-quick-add]');
    if (!form) return;
    e.preventDefault();
    var msg = form.querySelector('[data-tp-msg]');
    var input = form.querySelector('[name=id]');
    if (!input || !input.value) { say(msg, form.getAttribute('data-missing')); if (input) input.focus(); return; }
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    addItems([{ id: Number(input.value), quantity: 1 }])
      .then(function () { say(msg, form.getAttribute('data-added')); })
      .catch(function (err) { say(msg, err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* Change size of a line in the cart */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-tp-line-size]');
    if (!sel) return;
    var key = sel.getAttribute('data-key');
    var qty = Number(sel.getAttribute('data-qty')) || 1;
    var id = Number(sel.value);
    sel.disabled = true;
    post('cart/change.js', { id: key, quantity: 0 })
      .then(function () { return addItems([{ id: id, quantity: qty }]); })
      .then(function () { if (window.location.pathname === root + 'cart') window.location.reload(); })
      .catch(function (err) {
        sel.disabled = false;
        var errEl = sel.closest('.cart-item') && sel.closest('.cart-item').querySelector('[data-line-item-error]');
        say(errEl, err.message);
      });
  });

  /* Keep set pickers on the colour she has chosen */
  function currentColour(scope) {
    var checked = scope.querySelector('input[type=radio][name*="Colour"]:checked, input[type=radio][name*="Color"]:checked');
    if (checked) return checked.value;
    var sel = scope.querySelector('select[name*="Colour"], select[name*="Color"]');
    return sel ? sel.value : null;
  }
  function syncSet() {
    var set = document.querySelector('[data-tp-set-form]');
    if (!set) return;
    var colour = currentColour(document);
    set.querySelectorAll('select[data-tp-set-select]').forEach(function (s) {
      var hasMatch = false;
      s.querySelectorAll('option[data-colour]').forEach(function (o) {
        var show = !colour || o.getAttribute('data-colour') === colour;
        if (show) hasMatch = true;
        o.hidden = !show;
        o.disabled = !show || o.hasAttribute('data-sold-out');
      });
      if (!hasMatch) { s.querySelectorAll('option[data-colour]').forEach(function (o) { o.hidden = false; o.disabled = o.hasAttribute('data-sold-out'); }); }
      var cur = s.options[s.selectedIndex];
      if (cur && cur.hidden) s.value = '';
    });
  }
  document.addEventListener('change', function (e) { if (e.target.matches('input[type=radio], select') && !e.target.closest('[data-tp-set-form]')) syncSet(); });
  document.addEventListener('DOMContentLoaded', syncSet);

  /* Sticky add to bag on mobile */
  function initSticky() {
    var bar = document.querySelector('[data-tp-sticky]');
    var form = document.querySelector('product-form');
    var target = form && form.querySelector('button[name=add]');
    if (!bar || !target) return;
    var btn = bar.querySelector('button');
    var ticking = false;
    function update() {
      ticking = false;
      var vis = target.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', vis);
      bar.setAttribute('aria-hidden', vis ? 'false' : 'true');
      btn.tabIndex = vis ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    btn.addEventListener('click', function () {
      if (target.disabled) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      target.click();
    });
  }
  document.addEventListener('DOMContentLoaded', initSticky);
})();
